export default {
  path: '/transfer',
  name: 'transfer',
  component: () => import('@/views/transfer/Index'),
  redirect: { name: 'transfers-upcoming' },
  children: [
    {
      path: 'transfers',
      component: () => import('@/views/transfer/transfers/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/transfer/transfers/Layout'),
          children: [
            {
              path: '',
              name: 'transfers-upcoming',
              component: () => import('@/views/transfer/transfers/Upcoming'),
              meta: {
                title: 'Upcoming transfers',
                roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant', 'sales_manager', 'safari_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'hotel_reception', 'hotel_supervisor']
              }
            },
            {
              path: 'archive',
              name: 'transfers-archive',
              component: () => import('@/views/transfer/transfers/Archive'),
              meta: {
                title: 'Archive transfers',
                roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant', 'sales_manager', 'safari_manager', 'sales_supervisor', 'operations_supervisor', 'hotel_reception', 'hotel_supervisor']
              }
            }
          ]
        },
      ]
    },
    {
      path: 'fast-track',
      component: () => import('@/views/transfer/fast-track/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/transfer/fast-track/Layout'),
          redirect: { name: 'fast-track-upcoming' },
          children: [
            {
              path: '',
              name: 'fast-track-upcoming',
              component: () => import('@/views/transfer/fast-track/Upcoming'),
              meta: {
                title: 'Upcoming fast track',
                roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant', 'sales_manager', 'sales_supervisor']
              }
            },
            {
              path: 'archive',
              name: 'fast-track-archive',
              component: () => import('@/views/transfer/fast-track/Archive'),
              meta: {
                title: 'Archive fast track',
                roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant', 'sales_manager', 'sales_supervisor']
              }
            },
          ]
        },
        {
          path: ':id',
          name: 'fast-track-detail',
          component: () => import('@/views/transfer/fast-track/Detail'),
          meta: {
            title: 'Detail fast track',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant', 'sales_manager', 'sales_supervisor']
          }
        },
      ]
    },
    {
      path: 'taxi-drivers',
      component: () => import('@/views/transfer/taxi-drivers/Index'),
      children: [
        {
          path: '',
          name: 'taxi-drivers-list',
          component: () => import('@/views/transfer/taxi-drivers/List'),
          meta: {
            title: 'Taxi drivers',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
        {
          path: ':id',
          name: 'taxi-drivers-detail',
          component: () => import('@/views/transfer/taxi-drivers/Detail'),
          meta: {
            title: 'Taxi drivers',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
      ]
    },
    {
      path: 'rental-companies',
      component: () => import('@/views/transfer/rental-companies/Index'),
      children: [
        {
          path: '',
          name: 'rental-companies-list',
          component: () => import('@/views/transfer/rental-companies/List'),
          meta: {
            title: 'Rental companies',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
        {
          path: ':id',
          name: 'rental-companies-detail',
          component: () => import('@/views/transfer/rental-companies/Detail'),
          meta: {
            title: 'Rental companies',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
      ]
    },
    {
      path: 'calculator',
      name: 'transfer-calculator',
      component: () => import('@/views/transfer/calculator/Layout'),
      redirect: { name: 'transfer-regular' },
      children: [
        {
          path: '',
          name: 'transfer-regular',
          component: () => import('@/views/transfer/calculator/Regular'),
          meta: {
            title: 'Transfer',
            roles: ['general_manager']
          }
        },
        {
          path: 'advanced',
          name: 'transfer-advanced',
          component: () => import('@/views/transfer/calculator/Advanced'),
          meta: {
            title: 'Transfer',
            roles: ['general_manager']
          }
        },
      ]
    },
    {
      path: 'allowance',
      component: () => import('@/views/transfer/allowance/Index'),
      children: [
        {
          path: '',
          name: 'transfer-allowance-list',
          component: () => import('@/views/transfer/allowance/List'),
          meta: {
            title: 'Driver’s allowance',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
        {
          path: ':id',
          name: 'transfer-allowance-detail',
          component: () => import('@/views/transfer/allowance/Detail'),
          meta: {
            title: 'Driver allowance',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
      ]
    },
    {
      path: 'schedule',
      component: () => import('@/views/transfer/schedule/Layout'),
      children: [
        {
          path: '',
          name: 'transfer-schedule-own',
          component: () => import('@/views/transfer/schedule/Own'),
          meta: {
            title: 'Own cars Schedule',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
        {
          path: 'rental-cars',
          name: 'transfer-schedule-rental',
          component: () => import('@/views/transfer/schedule/Rental'),
          meta: {
            title: 'Rental cars Schedule',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
        {
          path: 'taxi',
          name: 'transfer-schedule-taxi',
          component: () => import('@/views/transfer/schedule/Taxi'),
          meta: {
            title: 'Taxi drivers Schedule',
            roles: ['general_manager', 'transfer_manager', 'transfer_supervisor', 'transfer_assistant']
          }
        },
      ]
    },
    {
      path: 'analytics',
      name: 'transfer-analytics',
      component: () => import('@/views/transfer/Analytics'),
      meta: {
        title: 'Transfer analytics',
        roles: ['general_manager']
      }
    }
  ]
}